<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <card v-ripple color="white" align="center" :title="$lang.clickMeForRipple" :class="['py-4', 'cursor-pointer']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness">
          <card-text :class="['text-xl']">{{ $lang.clickMeForRipple }}</card-text>
        </card>
      </flex-col>
    </flex>
    <all-section-blocks :title="true" :tooltip="false" />
  </container>
</template>
<script>
export default {
  name: 'PageRipple'
}
</script>



// WEBPACK FOOTER //
// src/pages/directives/ripple.vue